import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cleanPertinentCategory, DBDef_PertinentCategory } from '@app/advisor-ui-shared';
import { createWorkHubManager } from '@app/styles';
import { LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import { ModuleFE_PertinentCategory } from '../../../_entity.js';
import { Editor_PertinentCategory } from './Editor_PertinentCategory/Editor_PertinentCategory.js';
import { Header_PertinentCategory } from './Header_PertinentCategory/Header_PertinentCategory.js';
import './Manager_PertinentCategory.scss';
const EditorWrapper = (props) => {
    return _jsxs(LL_V_L, { className: 'm__pertinent-category', children: [_jsx(Header_PertinentCategory, { editable: props.editable, workHubItem: props.workHubItem, tabId: props.tabId }), _jsx(Editor_PertinentCategory, { editable: props.editable, editMode: props.renderArgs.editMode })] });
};
export const Manager_PertinentCategory = createWorkHubManager({
    module: ModuleFE_PertinentCategory,
    dbDef: DBDef_PertinentCategory,
    defaultItem: cleanPertinentCategory,
    labelResolver: (item) => item.label ?? 'New Pertinent Category',
    EditorComponent: EditorWrapper,
});
//# sourceMappingURL=Manager_PertinentCategory.js.map